import { useQuery } from '@tanstack/react-query';
import { getBrokerConfig, getBrokerLearnConfig } from '../services/learn';
import { IBrokerConfig, IBrokerLearnConfig } from '../types/master-data';

const brokerLearnCache: { [brandName: string]: any } = {};

export const useBrokerConfig = (brandName: string) => {
  return useQuery<IBrokerConfig>({
    queryKey: ['broker-config', brandName],
    queryFn: async () => {
      const data = await getBrokerConfig({ brandName });
      return data;
    },
    refetchInterval: 60 * 1000,
  });
};

export const useBrokerLearn = (
  brandName: string,
  product: string,
  category: string
) => {
  return useQuery<IBrokerLearnConfig>({
    queryKey: ['broker-learn', brandName],
    queryFn: async () => {
      const data = await getBrokerLearnConfig({ brandName, product, category });
      brokerLearnCache[brandName] = data;
      return data;
    },
  });
};
